module.exports = __webpack_public_path__ + "img/keycloak-logo.31e5ce66.svg";